import { Modal, ModalBody } from "react-bootstrap";
import AnnouncementCreate from "../../components/Announcement/AnnouncementCreate";
import { ChangeEvent, useState } from "react";
import { createAnnouncement } from "../../api/announcement";

interface Props {
  onClose: () => void;
  fetchAnnouncements: () => void;
}

const AnnouncementCreateContainer = ({ onClose, fetchAnnouncements }: Props) => {
  const [item, setItem] = useState({
    title: "",
    content: "",
    is_published: false,
    sort_order: ""
  });

  const handleChange = ({ target }: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = target;
    setItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreate = async () => {
    try {
      await createAnnouncement(item);
      fetchAnnouncements();
      onClose();
    } catch (e: any) {
      alert(e.response.data.message);
    }
  };

  return (
    <Modal show onHide={onClose} centered backdrop="static">
      <ModalBody style={{ margin: 0, padding: 0 }}>
        <AnnouncementCreate item={item} onClose={onClose} handleChange={handleChange} handleSubmit={handleCreate} />
      </ModalBody>
    </Modal>
  );
};

export default AnnouncementCreateContainer;
